<template>
  <CustomPage :noBorder="true">
    <div slot="content" class="content">
      <VImage :src="require('@/assets/logo-white.png')" class="logo" />
      <div class="phone">
        <span class="number">{{ phone_c }}</span>
        <span class="label">用户</span>
      </div>
      <div class="btn-invite-code">
        <Field
          class="input"
          v-model="inviteCode"
          placeholder="输入邀请码"
          maxlength="6"
          autofocus
        />
      </div>
      <div class="btn-enter" @click="confirm">点击进入</div>
      <div class="tip">无邀请码请联系您的上级</div>
    </div>
  </CustomPage>
</template>

<script>
import { mapState } from 'vuex'
import { Image as VImage, Field, Toast } from 'vant'
import { confirmInviteCode } from '@/api/login'
import CustomPage from '@/components/custom-page.vue'
export default {
  components: { CustomPage, VImage, Field },
  data() {
    return {
      inviteCode: this.$route.query.invitationCode,
    }
  },
  computed: {
    ...mapState({
      userInfoAccount: (state) => state.user.userInfoAccount
    }),
    phone_c() {
      return this.userInfoAccount.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
    }
  },
  methods: {
    confirm() {
      if (this.inviteCode) {
        this.confirmHandle()
      } else {
        Toast.fail('请输入邀请码')
      }
    },
    // 验证邀请码
    confirmHandle() {
      const params = {
        inviteCode: this.inviteCode,
      }
      this.$store.dispatch('app/showLoading')
      confirmInviteCode(params)
        .then((res) => {
          this.$store.dispatch('app/hideLoading')
          Toast.success('邀请码验证成功，请重新登录')
          this.logout()
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    logout() {
      this.$store.dispatch('user/resetToken')
      this.$router.push('/login')
    },
  }
}
</script>

<style lang="less" scoped>
.content {
  height: 100%;
  width: 100%;
  background: #C82D26;
  padding: 0 74px;
  padding-top: 150px;
  text-align: center;
  .logo {
    width: 366px;
    margin-bottom: 152px;
  }
  .phone {
    color: #fff;
    padding-bottom: 40px;
    font-size: 48px;
    line-height: 66px;
    font-weight: bold;
  }
  .btn-invite-code {
    background: #fff;
    color: #c82d26;
    margin-bottom: 40px;
    border-radius: 80px;
    padding: 4px 0;
    overflow: hidden;
    .input {
      font-size: 26px;
      line-height: 26px;
    }
    .input /deep/ input {
      text-align: center;
      color: #c82d26;
      &::placeholder {
        color: #c82d26;
      }
    }
  }
  .btn-enter {
    border-radius: 80px;
    text-align: center;
    font-weight: bold;
    font-size: 26px;
    line-height: 80px;
    color: #fff;
    border: 1px solid #fff;
    box-sizing: border-box;
  }
  .tip {
    font-size: 26px;
    font-weight: 500;
    color: #ffffff;
    line-height: 36px;
    margin-top: 40px;
  }
}
</style>